import i18n from 'modules/core/lib/i18n'

export interface ResolvedTemplate {
  id: string
  name: string
  description: string
  categories: Array<{ name: string; description: string }>
}

export const getTemplates = (): ResolvedTemplate[] => [
  {
    id: 'it_support',
    name: i18n.t('ticketing.onboarding.template_it_support_name'),
    description: i18n.t('ticketing.onboarding.template_it_support_description'),
    categories: [
      {
        name: i18n.t('ticketing.onboarding.template_it_support_cat_hardware'),
        description: i18n.t('ticketing.onboarding.template_it_support_cat_hardware_description'),
      },
      {
        name: i18n.t('ticketing.onboarding.template_it_support_cat_software'),
        description: i18n.t('ticketing.onboarding.template_it_support_cat_software_description'),
      },
      {
        name: i18n.t('ticketing.onboarding.template_it_support_cat_access'),
        description: i18n.t('ticketing.onboarding.template_it_support_cat_access_description'),
      },
    ],
  },
  {
    id: 'hr_requests',
    name: i18n.t('ticketing.onboarding.template_hr_requests_name'),
    description: i18n.t('ticketing.onboarding.template_hr_requests_description'),
    categories: [
      {
        name: i18n.t('ticketing.onboarding.template_hr_requests_cat_onboarding'),
        description: i18n.t('ticketing.onboarding.template_hr_requests_cat_onboarding_description'),
      },
      {
        name: i18n.t('ticketing.onboarding.template_hr_requests_cat_documentation'),
        description: i18n.t(
          'ticketing.onboarding.template_hr_requests_cat_documentation_description'
        ),
      },
      {
        name: i18n.t('ticketing.onboarding.template_hr_requests_cat_general'),
        description: i18n.t('ticketing.onboarding.template_hr_requests_cat_general_description'),
      },
    ],
  },
  {
    id: 'facilities',
    name: i18n.t('ticketing.onboarding.template_facilities_name'),
    description: i18n.t('ticketing.onboarding.template_facilities_description'),
    categories: [
      {
        name: i18n.t('ticketing.onboarding.template_facilities_cat_equipment'),
        description: i18n.t('ticketing.onboarding.template_facilities_cat_equipment_description'),
      },
      {
        name: i18n.t('ticketing.onboarding.template_facilities_cat_workplace'),
        description: i18n.t('ticketing.onboarding.template_facilities_cat_workplace_description'),
      },
      {
        name: i18n.t('ticketing.onboarding.template_facilities_cat_supplies'),
        description: i18n.t('ticketing.onboarding.template_facilities_cat_supplies_description'),
      },
    ],
  },
]
